import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";

const QRListTable = (props) => {
  const {
    selectedData,
    productData,
    handleChangeItem,
    summedQty,
    mode,
    remainingQty,
    totalQnt,
  } = props;

  return (
    <div className="mx-4 my-4">
      <div className="w-full flex">
        <div
          className={`${
            mode === "full"
              ? "bg-button-red border-button-red text-white"
              : "bg-primary-grey border-primary-grey border text-[#767676]"
          } cursor-pointer py-2 text-center border w-full`}
        >
          전체 배송
        </div>
        <div
          className={`${
            mode === "partial"
              ? "bg-button-red border-button-red text-white"
              : "bg-primary-grey border-primary-grey border text-[#767676]"
          } cursor-pointer py-2 text-center border w-full`}
        >
          부분 배송
        </div>
      </div>

      <div className="flex mt-3">
        <div className="flex">
          <div className="bg-input-grey border text-center w-20 py-2 border-primary-grey">
            주문 수량
          </div>
          <div className="border mr-2 w-24 text-center border-l-0 flex">
            <span className="m-auto">
              {mode === "full" ? (
                productData?.quantity
              ) : (
                <span>
                  <span className="text-[#0054ff] font-bold">
                    {summedQty ?? 0}
                  </span>
                  /{remainingQty}
                </span>
              )}
            </span>
          </div>
        </div>
        <ArrowRightIcon fontWeight={800} width={37} />
        <div className="flex">
          <div className="bg-input-grey ml-2 border text-center w-28 py-2 border-primary-grey">
            (발송) 출고수량
          </div>
          <div className="border w-12 border-r-0 text-center border-l-0 flex">
            <span className="m-auto">{summedQty ?? 0}</span>
          </div>
        </div>
        <div className="flex">
          <div className="bg-input-grey border text-center w-20 py-2 border-primary-grey">
            잔여 수량
          </div>
          <div className="border w-24 text-center font-bold text-dark-red border-l-0 flex">
            <span className="m-auto">{productData?.quantity - summedQty}</span>
          </div>
        </div>
        <div className="flex">
          <div className="bg-drop-yellow border border-l-0 text-center w-28 py-2 border-drop-yellow">
            출고 후 재고수량
          </div>
          <div className="border w-14 text-center font-bold text-dark-red border-l-0 flex">
            <span className="m-auto">{totalQnt - summedQty}</span>
          </div>
        </div>
      </div>

      <div className="bg-primary-blue text-white flex justify-between mt-3 px-4 py-2.5">
        <div>재고정보 (현재 재고수량 : {productData?.quantity}개)</div>
        <div>※ 주문수량 범위내에서 '(발송) 출고수량을 입력할 수 있습니다.</div>
      </div>
      <div className="h-[10rem] overflow-auto">
        <table className="min-w-full">
          <thead>
            <tr className="bg-input-grey sticky top-0 font-bold text-center">
              <td className="border w-14 border-disable-grey py-2.5">번호</td>
              <td className="border border-disable-grey w-28 py-2.5">LOT</td>
              <td className="border w-44 border-disable-grey py-2.5">QR번호</td>
              <td className="border border-disable-grey py-2.5">제조일자</td>
              <td className="border border-disable-grey py-2.5">유효일자</td>
              <td className="border border-disable-grey py-2.5">재고수량</td>
              <td className="border border-disable-grey py-2.5">선택</td>
            </tr>
          </thead>
          <tbody>
            {selectedData
              .sort((a, b) => b.id - a.id)
              .map((item, index) => (
                <tr className="text-center" key={item.id}>
                  <td className="border py-2 border-disable-grey">
                    {selectedData?.length - index}
                  </td>
                  <td className="border w-20 py-2 border-disable-grey">
                    {item.productLotInfo.lotNo}
                  </td>
                  <td className="border py-2 border-disable-grey">
                    {item.qrNo}
                  </td>
                  <td className="border py-2 w-24 border-disable-grey">
                    {dayjs(item.productLotInfo.manufacDate).format(
                      "YYYY-MM-DD"
                    )}
                  </td>
                  <td className="border py-2 w-24 border-disable-grey">
                    {dayjs(item.productLotInfo.expireDate).format("YYYY-MM-DD")}
                  </td>
                  <td className="border py-2 w-20 border-disable-grey">
                    {item.qnt}
                  </td>
                  <td className="border w-20 py-2 px-2 border-disable-grey">
                    <input
                      type="number"
                      className="border rounded-[4px] p-2"
                      defaultValue={0}
                      // value={
                      //   selectedItem[
                      //     selectedData?.findIndex((res) => res.id === item.id)
                      //   ].qty
                      // }
                      onChange={(e) => handleChangeItem(e, item?.id, "qnt")}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QRListTable;
